
interface ProfileViewToggleProps {
  viewMode: 'private' | 'public';
  onViewModeChange: (mode: 'private' | 'public') => void;
  onEdit: () => void;
  onLogout: () => void;
}

export const ProfileViewToggle = ({ viewMode, onViewModeChange, onEdit, onLogout }: ProfileViewToggleProps) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
      <button
        onClick={() => onViewModeChange('private')}
        className={`px-4 py-2 rounded text-sm font-medium ${
          viewMode === 'private' 
            ? 'bg-green-600 text-white' 
            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
        }`}
      >
        Private View
      </button>
      <button
        onClick={() => onViewModeChange('public')}
        className={`px-4 py-2 rounded text-sm font-medium ${
          viewMode === 'public' 
            ? 'bg-green-600 text-white' 
            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
        }`}
      >
        Public Farm Profile
      </button>
      <button
        onClick={onEdit}
        className="px-4 py-2 rounded text-sm font-medium bg-green-600 text-white hover:bg-green-700"
      >
        Edit Profile
      </button>
      <button
        onClick={onLogout}
        className="px-4 py-2 rounded text-sm font-medium border border-red-200 text-red-600 hover:bg-red-50"
      >
        Log Out
      </button>
    </div>
  );
};
